var indentation_default = {
  "indentZero": "_8j14K",
  "indentOne": "pyWMa",
  "indentTwo": "_5DboD",
  "indentThree": "wC-jQ",
  "indentFour": "ia0Ri",
  "indentFive": "nXyYX",
  "indentSix": "VzgQK"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
